import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { System } from '../shared-components/System';
import { IepFormsWithinDocuments } from './forms-within-documents/formwithin-document-modal';
import { AccomodationBank, ComplianceRule } from './sped-management/sped-management.model';
import { SpedFixedUserPermission, SpedUserPermission } from './sped-user-permissions.model';

@Injectable({
  providedIn: 'root'
})
export class Sped360Service {
  spedFixedPermission = new SpedFixedUserPermission();
  spedUserPermission: SpedUserPermission[] = [];
  previousSelectedStudentId: number;
  collectionName: string;
  collectionCode: string;
  collectionStatus: string;
  collectionId: number;
  canEditForm = false;
  continueClicked = true;
  accommodationData = new AccomodationBank();
  complianceData = new ComplianceRule();
  formWithinDocumentData: any;

  constructor(private http: HttpClient) { }

  getSpEdFixedPermissionRead(yearId: number, siteId: number): Observable<SpedFixedUserPermission> {
    const queryString = '?yearId=' + yearId + '&siteId=' + siteId;
    return this.http.get<SpedFixedUserPermission>(System.apiURL.SpecialEd + 'GetSpEdFixedPermissionRead' + queryString);
  }

  getSpEdUserPermissionByUserId(yearId: number, siteId: number): Observable<SpedUserPermission[]> {
    const queryString = '?yearId=' + yearId + '&siteId=' + siteId;
    return this.http.get<SpedUserPermission[]>(System.apiURL.SpecialEd + 'GetSpEdUserPermissionReadByUserId' + queryString);
  }

  allowToEditDelete(isEdit: boolean): boolean {
    if (this.collectionStatus == 'Working Draft') {
      if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocuments) || (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504Documents)) {
        return true;
      } else if (this.spedUserPermission.filter(x => x.CollectionId == this.collectionId && x.Maintain == true).length > 0) {
        return true;
      } else {
        if (isEdit == true) {
          return true;
        } else {
          return false;
        }
      }
    } else if (this.collectionStatus == 'Reviewed by Supervisor' || this.collectionStatus == 'Completed') {
      if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocumentsInFinalStatus) || (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504DocumentsInFinalStatus)) {
        return true;
      } else if (this.spedUserPermission.filter(x => x.CollectionId == this.collectionId && x.MaintainInFinalStatus).length > 0) {
        return true;
      } else {
        return false;
      }
    } else if (this.collectionName == 'IEP' && this.collectionStatus == 'Completed by Case Manager' && this.spedFixedPermission.MaintainAllSpEdDocumentInCompletedByCaseManagerStatus) {
      return true;
    }
    else {
      return false;
    }
  }

  editHtmlFormdropDownValue(ddList: IepFormsWithinDocuments[]): IepFormsWithinDocuments[] {
    if ((!this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAllSpEdDocuments == false && (this.collectionStatus != 'Completed by Case Manager' || this.spedFixedPermission.MaintainAllSpEdDocumentInCompletedByCaseManagerStatus == false)
      && this.spedFixedPermission.MaintainAllSpEdDocumentsInFinalStatus == false) ||
      (this.collectionCode.includes('504') && this.spedFixedPermission.MaintainAll504Documents == false
        && this.spedFixedPermission.MaintainAll504DocumentsInFinalStatus == false)) {
      if (this.spedUserPermission.filter(x => x.CollectionId == this.collectionId).length > 0 && (this.spedUserPermission.find(x => x.CollectionId == this.collectionId).Maintain == false && this.spedUserPermission.find(x => x.CollectionId == this.collectionId).MaintainInFinalStatus == false)) {
        return ddList.filter(d => d.IsEdit == true);
      }
    }
    return ddList;
  }

  getaccommodationData(exportType, delimiter, otherDelimiter, includeColumnHeadings, filename, active, type): Observable<string> {
    const assigneddelimeter = otherDelimiter == undefined ? '' : otherDelimiter;
    return this.http.get<string>(System.apiURL.SpecialEd + `GetAccomodationExportData?spedlookupmasterid=${this.accommodationData.MasterId}
     &displaymasteronly=${false}
     &spedlookupdataid=${0}
     &type=${type}
     &exportType=${exportType}
     &colDelimiter=${delimiter}
     &otherDelimiter=${encodeURIComponent(assigneddelimeter)}
     &fileName=${filename}
     &displayHeader=${includeColumnHeadings}
     &columnToShow=${active}`);
  }

  getComplianceExportData(stateCode, exportType, delimiter, otherDelimiter, includeColumnHeadings, filename, active): Observable<string> {
    const assigneddelimeter = otherDelimiter == undefined ? '' : otherDelimiter;
    return this.http.get<string>(System.apiURL.SpecialEd + `GetComplianceExportData?stateCode=${stateCode}
     &spedCollectionId=${this.complianceData.CollectionId}
     &spedTemplateVersionId=${this.complianceData.TemplateVersionId}
     &exportType=${exportType}
     &colDelimiter=${delimiter}
     &otherDelimiter=${encodeURIComponent(assigneddelimeter)}
     &fileName=${filename}
     &displayHeader=${includeColumnHeadings}
     &columnToShow=${active}`);
  }

  getGoalBankExportData(exportType, delimiter, otherDelimiter, includeColumnHeadings, filename, goalSetting, type): Observable<string> {
    const assigneddelimeter = otherDelimiter == undefined ? '' : otherDelimiter;
    return this.http.get<string>(System.apiURL.SpecialEd + `GetGoalBankExportData?categoryId=${0}
     &dataBankId=${0}
     &type=${type}
     &exportType=${exportType}
     &colDelimiter=${delimiter}
     &otherDelimiter=${encodeURIComponent(assigneddelimeter)}
     &fileName=${filename}
     &displayHeader=${includeColumnHeadings}
     &goalSetting=${goalSetting}`);
  }


  exportBase64ToFile(base64Document: string, fileName: string, fileType: string) {
    const byteArrays: any[] = [];
    const byteCharacters = atob(base64Document);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
    const blob = new Blob(byteArrays, { type: fileType });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.style.visibility = 'hidden';
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}